import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import styled from "styled-components";
import { useFormikContext, useField } from "formik"; // Changed from react-hook-form
import { useTranslation } from "react-i18next";

const CustomInput = forwardRef(
  ({ value, onClick, disabled, placeholderText }, ref) => (
    <input
      ref={ref}
      value={value}
      onClick={onClick}
      readOnly
      disabled={disabled}
      placeholder={placeholderText}
      className="form-control"
    />
  ),
);

CustomInput.displayName = "CustomInput";

const ArchiveDateField = ({
  name,
  placeholder,
  icon: Icon,
  disabled,
  minDate,
  maxDate,
  yearDropdown = true,
  monthDropdown = true,
  onDateChange,
  border,
  ...rest
}) => {
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  return (
    <DatepickerWrapper border={border} {...rest}>
      <DatePicker
        // Formik state management
        selected={(field.value && new Date(field.value)) || null}
        onChange={(date) => {
          setFieldValue(name, date);
          if (onDateChange) onDateChange(name, date);
        }}
        // Configuration
        dateFormat="yyyy/MM/dd"
        showMonthDropdown={monthDropdown}
        showYearDropdown={yearDropdown}
        dropdownMode="select"
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        // UI Customization
        customInput={
          <CustomInput disabled={disabled} placeholderText={placeholder} />
        }
        {...(Icon && { showIcon: true, icon: <Icon /> })}
      />

      {/* Formik Error Handling */}
      {meta.touched && meta.error && (
        <>
          <p className="text-danger text-sm mb-0 mt-1">{t(meta.error)}</p>
        </>
      )}
    </DatepickerWrapper>
  );
};

// --- DESIGN (Kept identical to your provided styles) ---
const DatepickerWrapper = styled.div`
  width: 100%;
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker-wrapper .form-control {
    background-color: ${({ bg }) => (bg ? bg : "var(--white)")};
    border: ${({ border }) =>
      border ? "none" : "1px solid var(--borderLight)"};
    height: 48px;
    box-shadow: none;
    outline: none;
    border-radius: 10px;
    color: var(--text);
    font-size: 14px;
    &::placeholder {
      color: var(--text2);
    }
  }

  .react-datepicker__input-container {
    display: flex;
    align-items: center;
  }

  .react-datepicker__calendar-icon {
    width: 18px;
    height: 19px;
    padding-top: 5px;
  }

  .react-datepicker__view-calendar-icon input {
    padding: 6px 10px 5px 33px;
    body.rtl & {
      padding: 6px 33px 5px 10px;
    }
  }

  .form-control:focus {
    box-shadow: none;
    outline: none;
  }
`;

export default ArchiveDateField;
